import React from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import logo from '../../assets/images/dap-logo.png';
import './header.css';

const Header = () => {
  return (
    <Row noGutters>
      <Col md={12}>
        <h3>
          <Image src={logo} className="icono-dap" alt="Ícono DAP" />
          Depósitos a Plazo
        </h3>
        <hr />
      </Col>
    </Row>
  );
};

export default Header;
